export default __webpack_public_path__ + "static/media/Intro-Card-3.1dcff5ef.svg";